// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__Hdi8s","graphics":"styles_graphics__Sh9Bz"};